const messages = {
    availPoints: "Dostupné body",
    awaitingPoints: "Čekající body",
  board: {
    title: "Přehled",
    title2: "Animace výkonu {year}",
    headline1: "Vaše akce a body na první pohled",
    headline2: "Získejte body za nákupy pneumatik.",
    pointsBalanceToDate: "STAV BODŮ K DATU",
    availPoints: "Dostupné body",
    awaitingPoints: "Čekající body",
    yourRealisation: "VAŠE DOSAŽENÍ",
    yourEngagement: "Váš roční závazek: <b>{tyres} pneumatik</b>",
    yourPoints: "VAŠE BODY",
    yourRetailPurchase: "VAŠE MALOOBCHODNÍ NÁKUPY",
    yourRetailPurchaseCCS: "VÁŠ MALOOBCHODNÍ PRODEJ",
    pointsByPurchase: "body vygenerované vašimi nákupy",
    pointsByBoosters: "body vygenerované boostery",
    pointsByBSPurchase: "Body vygenerované vašimi nákupy Bridgestone",
    pointsByBSPurchaseCCS:
      "Body vygenerované vaším prodejem pneumatik Bridgestone",
    remaining: "Zbývající pneumatiky",
    yourGoal: "Postup k cíli",
    unit: "pneumatik",
    buttons: {
      learnMore: "Zjistit více o vašich bodech",
      learnMoreAboutMechanism: "Zjistit více o mechanismu",
    },
    charts: {
      byBrand: "Podle značky",
      bySize: "Podle velikosti<br/>ráfků",
    },
    exploreResults: "Objevte své výsledky",
    tyreLimitInfo:
      "Pro každé období kampaně Booster je vyžadován minimální vyprodaný objem 50 pneumatik Bridgestone a/nebo Firestone",
  },
  charts: {
    byBrand: "Podle značky",
    bySize: "podle velikosti ráfků",
  },

  dashboard: {
    dashboardTitle: "Vaše výhody",
    dashboardBox: {
      title: "Stav bodů",
      description: "Váš aktuální celkový počet marketingových bodů",
      availPoints: "Dostupné body",
      awaitingPoints: "Čekající body",
      lastUpdate: "Poslední aktualizace",
      button: "Zjistit více",
      points: "bodů",
    },
  },
  soldTyres: "PRODANÉ PNEUMATIKY",
  receivedPoints: "ZÍSKANÉ BODY",
  boosterCCS: {
    personalInfo: "Osobní údaje",
    csNumberTitle: "Uveďte prosím číslo (čísla) účastnického účtu",
    tyresTitle: "Uveďte prosím počet prodaných pneumatik",
    minTyresInfo:
      "Je vyžadováno minimálně {tyres} pneumatiky Bridgestone/Firestone. Kompenzace se vztahuje pouze na pneumatiky Bridgestone.",
    tyresAmount: "Počet pneumatik",
    filesTitle: "Nahrajte prosím doklad o prodeji",
    filesDescription:
      "Upozornění: budou zohledněny pouze prodeje s uvedenou velikostí ráfku pneumatiky.",
    addAnotherFile: "Přidat další dokument",
    file: "Nahrát dokument",
    formatInfo:
      "Přijímané formáty souborů: xlsx, jpeg a pdf. Maximální velikost souboru: 8 MB",
    confrimationMessage:
      "<b>Děkujeme za vaši účast!</b> <br/>Vaše žádost byla přijata a předána týmům Bridgestone k ověření.<br/>Obdržíte e-mailové upozornění s výsledky vaší účasti v Booster CCS.<br/>Brzy se uvidíme na Bridgestone Plus!",
  },
  sharePointModal: {
    header: "Sdílet body",
    forShare: "Body, které sdílíte",
    title: "Název",
  },
  notFoundFile: "Nic nevybráno",
  chooseFile: "Vybrat soubor",
};
export default {
  messages,
};
